import React from "react";
import connect from "Shared/connect";
import { get, set } from "Shared/local-storage";
const STORAGE_NAME = "TabsInEditMode";
class TabInEditModeHandler extends React.Component {
    constructor(props) {
        super(props);
        this.uniqueTabIdentifyer = (Math.random() + 1).toString(36).substring(3);
        this.props.setref(this);
    }
    componentDidMount() {
        this.setNewState(this.props.isInEdit);
        window.onbeforeunload = () => {
            this.removeTab();
        };
    }
    componentWillUnmount() {
        this.removeTab();
    }
    componentDidUpdate(prevProps) {
        if (this.props.isInEdit !== prevProps.isInEdit) {
            this.setNewState(this.props.isInEdit);
        }
        if (this.props.currentUser.isLoggedIn !== prevProps.currentUser.isLoggedIn) {
            this.clearAllTabs();
        }
    }
    getStateFromStore() {
        return get(STORAGE_NAME, {});
    }
    setNewState(state) {
        const store = this.getStateFromStore();
        store[this.uniqueTabIdentifyer] = state;
        set(STORAGE_NAME, store);
    }
    removeTab() {
        let store = this.getStateFromStore();
        delete store[this.uniqueTabIdentifyer];
        set(STORAGE_NAME, store);
    }
    clearAllTabs() {
        set(STORAGE_NAME, {});
    }
    anyTabInEditMode() {
        const store = this.getStateFromStore();
        return Object.keys(store).some((tab) => Boolean(store[tab]));
    }
    render() {
        return React.createElement("div", null);
    }
}
export default connect((state) => ({
    currentUser: state.currentUser,
    isInEdit: state.appShellData.pageIsInEditMode,
}), (dispatch) => ({}))(TabInEditModeHandler);
